import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';

export enum VideoGtagEvent {
    PLAY = 'video_play',
    STOP = 'video_stop',
    PAUSE = 'video_pause',
    ENDED = 'video_ended',
    PROGRESS = 'video_progress'
}

@Injectable({
    providedIn: 'root'
})
export class GtagService {

    constructor(@Inject(PLATFORM_ID) protected platform) { }

    private fireEvent(event, eventModel) {
        if (isPlatformBrowser(this.platform)) {
            if (!environment.production) {
                console.debug('event', event, eventModel);
            }

            if (window['dataLayer']) {
                window['dataLayer'].push({ event, eventModel });
            }
        }
    }

    public firePageView(path) {
        if (isPlatformBrowser(this.platform)) {
            if (!environment.production) {
                console.debug('set', 'page_path', path);
            }
            if (window['dataLayer']) {
                window['dataLayer'].push({ event: 'page_view', page_path: path });
            }
        }
    }

    public fireThirdPartyOpenEvent(job_id: string, job_title: string) {
        this.fireEvent('job_third_party_open', {
            job_id,
            job_title,
        });
    }

    public fireThirdPartyApplyEvent(job_id: string, job_title: string) {
        this.fireEvent('job_third_party_apply', {
            job_id,
            job_title,
        });
    }

    public fireApplyEvent(job_id: string, job_title: string, application_id: string) {
        this.fireEvent('job_apply', {
            job_id,
            job_title,
            application_id,
        });
    }

    public fireOpenApplyDialogEvent(job_id: string, job_title: string) {
        this.fireEvent('job_apply_dialog_open', {
            job_id,
            job_title,
        });
    }

    public fireOpenJobDialogEvent(job_id: string, job_title: string) {
        this.fireEvent('job_dialog_open', {
            job_id,
            job_title,
        });
    }

    public fireOpenReferDialogEvent(job_id: string, job_title: string) {
        this.fireEvent('job_refer_dialog_open', {
            job_id,
            job_title,
        });
    }

    public fireReferralEvent(job_id: string, job_title: string) {
        this.fireEvent('referral', {
            job_id,
            job_title,
        });
    }

    public fireOpenLeadDialogEvent() {
        this.fireEvent('lead_dialog_open', {});
    }

    public fireLeadEvent() {
        this.fireEvent('sign_up', {});
    }

    public fireSearchEvent(search_term: string) {
        this.fireEvent('search', {
            search_term
        });
    }

    public fireShareEvent(platform: string) {
        this.fireEvent('share_click', {
            platform
        });
    }

    public fireVideoEvent(event: VideoGtagEvent, video_id: string, video_name: string, progress = 0) {
        this.fireEvent(event, {
            video_id,
            video_name,
            progress
        });
    }

}
